import React from 'react';

import Text from './Text';
import { colors } from '@styles/theme';

export default class Eyebrow extends React.PureComponent {
  render() {
    const { children, ...rest } = this.props;
    return (
      <Text.caption
        pl="2px"
        pb={2}
        as="div"
        color={colors.grayscale.black}
        style={{ textTransform: 'uppercase' }}
        data-testid="eyebrow"
        {...rest}
      >
        {children}
      </Text.caption>
    );
  }
}
